import { Table } from "@/features/Table";
import { type E2DynamicData, e2_dynamic_data_columns } from "./columns";

import { FilterE2DynamicDataSchema, FilterE2DynamicData } from "./filter";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";

export const E2DynamicDataTable = () => {
  return (
    <Table<E2DynamicData, FilterE2DynamicDataSchema>
      label="Dynamic Data"
      client={Clients.E2}
      table_name={Tables.E2_DYNAMIC_DATA}
      columns={e2_dynamic_data_columns}
      filter={<FilterE2DynamicData />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.E2}/${Tables.E2_DYNAMIC_DATA}/new`,
        },
      ]}
    />
  );
};
